import React, { useEffect } from 'react'
import { navigate } from '@reach/router'

import { firebaseSignout } from '../firebase/auth'

export default function SignoutPage() {
  /**
  |--------------------------------------------------
  | Signout
  |--------------------------------------------------
  */
  async function signout() {
    try {
      await firebaseSignout()
      navigate(`/signin`)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    signout()
  }, [])

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return <div></div>
}
